
/** 
  * Script for delay loading youtube videos and show it only when it is in visible viewport (on scroll)
*/

window.YoutubeDefer = window.YoutubeDefer || {};

YoutubeDefer.showYoutubeVideos = function() {
  let videosDefer = document.querySelectorAll(".youtube-video-deferred");
  for (let i=0; i < videosDefer.length; i++) {
    if(videosDefer[i].classList.contains("loaded")) return;
    if(videosDefer[i].getAttribute('data-video-id')) {
      let loadingDelay = 0;
      if(window.scrollY == 0) { //first screen
        loadingDelay = 4000;
      }
      let block = videosDefer[i];
      let parent = block.parentElement.parentElement;
      let parent_section = block.closest(".video-parent-section");
      if(typeof parent_section !== "null") {
        parent = parent_section;
      }
      if(YoutubeDefer.isVisibleElement(parent)) {
        parent.classList.add("loading");
        setTimeout(function() {
          let video_id = block.getAttribute('data-video-id');
          let video_layout = `
          <iframe 
            data-video-id="${video_id}" 
            frameborder="0" allowfullscreen="1" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            title="YouTube video player" 
            width="1280" height="720" 
            src="https://www.youtube.com/embed/${video_id}?mute=1&amp;autoplay=1&amp;autohide=0&amp;branding=0&amp;cc_load_policy=0&amp;controls=0&amp;fs=0&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;quality=hd720&amp;rel=0&amp;showinfo=0&amp;wmode=opaque&amp;enablejsapi=1" tabindex="-1">
          </iframe>
          `;
          block.innerHTML = video_layout;
          videosDefer[i].classList.add("loaded");
          console.log(`Video ${video_id} loaded`);
          setTimeout(function() {
            parent.classList.remove("loading");
            parent.classList.add("loaded");        
          }, 500); // delay just for show loading animation
        }, loadingDelay); // delay for first screen video (hero)
      }
    }
  }
}

YoutubeDefer.isVisibleElement = function(el) {
  const { top, bottom } = el.getBoundingClientRect();
  const vHeight = (window.innerHeight || document.documentElement.clientHeight);
  return (
    (top > 0 || bottom > 0) &&
    top < vHeight
  );
}

window.addEventListener('scroll', function() {
  setTimeout(function() { // prevent duplicate events
    YoutubeDefer.showYoutubeVideos();
  }, 100);
});
window.dispatchEvent(new CustomEvent('scroll'));